import createTranslateFunction from '../../i18n/createTranslateFunction';
import StatusContainer from './StatusContainer';

type trackingStatusBarProps = {
    isOrderDelivery: boolean;
};
const TrackingStatusBar = ({ isOrderDelivery }: trackingStatusBarProps) => {
    const StatusContainerTranslation = createTranslateFunction('track_order.delivery_statuses');
    const deliveryStatusContainerOptions = [0, 1, 3, 4];
    const pickupStatusContainerOptions = [0, 1, 4];
    return (
        <div
            className={`w-[50vw] relative flex flex-col ${isOrderDelivery ? `pt-[3vw]` : `pt-[10vw]`}`}
        >
            <span className="text-[1.8vw]">{StatusContainerTranslation('order_status')}</span>
            <div
                className={`z-[1] absolute ${isOrderDelivery ? `top-[29vw]` : `top-[29vw]`} right-[3.5vw] w-[0.3vw] h-[5.9vw] text-[3vw] rotate-90 text-white text-opacity-40`}
            >
                {isOrderDelivery ? `.............................` : `.....................`}
            </div>
            {isOrderDelivery
                ? deliveryStatusContainerOptions.map((index) => (
                      <StatusContainer
                          key={`status-container-${index}`}
                          isOrderDelivery={isOrderDelivery}
                          containerStatusValue={index}
                      />
                  ))
                : pickupStatusContainerOptions.map((index) => (
                      <StatusContainer
                          key={`status-container-${index}`}
                          isOrderDelivery={isOrderDelivery}
                          containerStatusValue={index}
                      />
                  ))}
        </div>
    );
};

export default TrackingStatusBar;
